import { DropdownOption } from '../../../core/models/DropdownOption';
import { CreateMatchPlayerCommandOfMatchPlayer, EventVm } from '../../../utils/api';
import MatchLineup from './MatchLineup';

export interface Props {
    isHomeTeam: boolean;
    teamId: number;
    events?: EventVm[];
    lineup: CreateMatchPlayerCommandOfMatchPlayer[];
    players: DropdownOption[];
    handleSelectLineupPlayer: (
        isHomeTeam: boolean,
        playerId: number,
        cap: number,
        capNumber: number
    ) => void;
    handleClearLineupPlayer: (isHomeTeam: boolean, cap: number) => void;
    onAutofillLineup?: () => void;
    autofillDisabled?: boolean;
    goalkeepers: number[];
    onToggleGoalkeeper: (isHomeTeam: boolean, cap: number) => void;
}

export default MatchLineup;
